module.exports = __webpack_public_path__ + "img/404-error.e465b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404-error.png
// module id = ./src/assets/images/404-error.png
// module chunks = 34